import { useQuery } from 'react-query';

import { levelService } from 'support/services';

export const useGetLevels = () => {
  const { data, isLoading, isError } = useQuery(
    'levels',
    ({ signal }) => levelService.getMany(signal),
    {
      keepPreviousData: false,
    }
  );

  return {
    records: data?.records ?? [],
    isLoading,
    isError,
  };
};
